<template>
  <section-collapseable
    hide-initial-when-expanded
    :is-loading="isLoading"
  >
    <div class="timeline">
      <div>
        <form-field-checkbox-buttons
          v-model="selectedFilters"
          :items="availableFilters"
          @change="updateSelectedItems"
        ></form-field-checkbox-buttons>
      </div>

      <timeline-list
        :items="timelineItems"
        :is-on-contact-modal="true"
        override-empty
      >
        <timeline-item
          type="Contact Created"
          :date="contactCreatedAt"
          :by-name="contactCreatedBy"
          icon="plus"
          outlined
          last
        ></timeline-item>
      </timeline-list>
    </div>
  </section-collapseable>
</template>

<script>
import TimelineList from "../../../components/timeline/TimelineList";
import {ENUMS} from "../../../services/enums";
import TimelineItem from "../../../components/timeline/TimelineItem";
import dates from "../../../services/dates";

export default {
  name: "ContactTimeline",
  components: {TimelineItem, TimelineList},
  props: {
    isLoading: {
      type: Boolean,
      default: false
    },
  },
  data() {
    return {
      selectedFilters: [
        'notes',
        'texts',
        'calls',
        'emails',
      ],
      availableFilters: [
        {
          value: 'notes',
          label: 'Notes',
          color: 'is-notes'
        },
        {
          value: 'texts',
          label: 'Texts',
          color: 'is-texts'
        },
        {
          value: 'calls',
          label: 'Calls',
          color: 'is-calls'
        },
        {
          value: 'emails',
          label: 'Emails',
          color: 'is-emails'
        },
      ]
    }
  },
  computed: {
    contact() {
      return this.$store.state.activeContact ? this.$store.state.activeContact.contact : {
        created_at: null,
        createdBy: {
          display_name: null,
        }
      };
    },
    contactCreatedAt() {
      return dates.formatAsDateTime(this.contact.created_at);
    },
    contactCreatedBy() {
      return this.contact.createdBy.display_name;
    },
    comms() {
      return this.$store.state.activeContact ? this.$store.state.activeContact.communicationLogs : [];
    },
    notes() {
      return this.$store.state.activeContact ? this.$store.state.activeContact.notes : [];
    },
    texts() {
      const comms = this.$utils.clone(this.comms);

      return comms.filter(comm => comm.type === ENUMS.CommunicationTypeEnum.Text.value);
    },
    calls() {
      const comms = this.$utils.clone(this.comms);

      return comms.filter(comm => comm.type === ENUMS.CommunicationTypeEnum.Call.value);
    },
    emails() {
      const comms = this.$utils.clone(this.comms);

      return comms.filter(comm => comm.type === ENUMS.CommunicationTypeEnum.Email.value);
    },
    timelineItems() {
      let notes = [];
      let texts = [];
      let calls = [];
      let emails = [];

      if(this.selectedFilters.includes('notes')) {
        notes = this.notes;
      }

      if(this.selectedFilters.includes('texts')) {
        texts = this.texts;
      }

      if(this.selectedFilters.includes('calls')) {
        calls = this.calls;
      }

      if(this.selectedFilters.includes('emails')) {
        emails = this.emails;
      }

      return [
        ...notes,
        ...texts,
        ...calls,
        ...emails,
      ]
    }
  },
  methods: {
    updateSelectedItems(value) {
      this.selectedFilters = value;
    }
  },
}
</script>

<style lang="scss" scoped>
@import "../../../styles/variables/variables";

</style>
